import { BREAKPOINTS } from './constants'

const detectBreakpoint = (target = '', width = window.innerWidth) => {
  switch (target) {
    case 'large':
      return width >= BREAKPOINTS.large
    case 'desktop-large':
      return width >= BREAKPOINTS.desktop
    case 'desktop':
      return width >= BREAKPOINTS.tablet
    case 'tablet':
      return width >= BREAKPOINTS.mobile && width < BREAKPOINTS.tablet
    default:
      return width < BREAKPOINTS.mobile
  }
}

const detectCurrentBreakpoint = () => {
  const width = window.innerWidth

  if (width < BREAKPOINTS.mobile) return 'mobile'
  if (width < BREAKPOINTS.tablet) return 'tablet'
  if (width < BREAKPOINTS.desktop) return 'desktop'
  if (width < BREAKPOINTS.large) return 'large'

  return 'desktop-large'
}

export { detectBreakpoint, detectCurrentBreakpoint }
